import React, { useEffect } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/plugins/counter.css';

const ProjectLightbox = ({ images, onClose }) => {
  const open = Boolean(images);

  // Closing must consume the history entry pushed on open, so the browser
  // back button/gesture dismisses the lightbox instead of leaving the page.
  useEffect(() => {
    if (!open) return;
    window.history.pushState({ lightbox: true }, '');
    const handlePopState = () => onClose();
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
      if (window.history.state && window.history.state.lightbox) {
        window.history.back();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Lightbox
      open={open}
      close={onClose}
      slides={(images || []).map((src) => ({ src }))}
      plugins={[Zoom, Thumbnails, Counter]}
      controller={{ closeOnPullDown: true, closeOnBackdropClick: true }}
      carousel={{ preload: 2 }}
      thumbnails={{ vignette: false }}
      styles={{ container: { backgroundColor: '#000' } }}
    />
  );
};

export default ProjectLightbox;
